import React from 'react';
import { Center, Divider, Flex, Text } from '@chakra-ui/react';

interface ProgressProps {
  isMultiple: boolean;
  step: number;
}

export const Progress = ({ isMultiple = false, step }: ProgressProps) => {
  return (
    <Flex
      aria-hidden="true"
      width="100%"
      alignItems="center"
      justify="center"
      mt="35px"
    >
      <Flex align="center" justify="center">
        <Center
          flexDirection="column"
          bg={step > 0 ? 'mutable.200' : 'grey.500'}
          mr="8px"
          w={6}
          h={6}
          rounded="full"
        >
          <Text
            fontSize="14px"
            mt={{ base: '20px', md: '0px' }}
            display="absolute"
            fontWeight="light"
          >
            1
          </Text>
          <Text
            fontSize="14px"
            display={{ base: 'absolute', md: 'none' }}
            color="text.100"
          >
            {isMultiple ? 'Serviços' : 'Veículo'}
          </Text>
        </Center>
        <Text display={{ base: 'none', md: 'block' }} color="text.100">
          {isMultiple ? 'Serviços' : 'Veículo'}
        </Text>
      </Flex>

      <Divider
        borderWidth="1px"
        borderColor={step > 1 ? 'black' : 'grey.500'}
        orientation="horizontal"
        maxW="109px"
        mx="8px"
        variant="dashed"
        _last={{ display: 'none' }}
      />

      <Flex align="center" justify="center">
        <Center
          flexDirection="column"
          bg={step > 1 ? 'mutable.200' : 'grey.500'}
          mr="8px"
          w={6}
          h={6}
          rounded="full"
        >
          <Text
            fontSize="14px"
            mt={{ base: '20px', md: '0px' }}
            display="absolute"
            fontWeight="light"
          >
            2
          </Text>
          <Text
            fontSize="14px"
            display={{ base: 'absolute', md: 'none' }}
            color="text.100"
          >
            {isMultiple ? 'Informações' : 'Serviços'}
          </Text>
        </Center>
        <Text display={{ base: 'none', md: 'block' }} color="text.100">
          {isMultiple ? 'Informações' : 'Serviços'}
        </Text>
      </Flex>

      <Divider
        borderWidth="1px"
        borderColor={step > 2 ? 'black' : 'grey.500'}
        orientation="horizontal"
        maxW="109px"
        mx="8px"
        variant="dashed"
      />

      <Flex align="center" justify="center">
        <Center
          flexDirection="column"
          bg={step > 2 ? 'mutable.200' : 'grey.500'}
          mr="8px"
          w={6}
          h={6}
          rounded="full"
        >
          <Text
            fontSize="14px"
            mt={{ base: '20px', md: '0px' }}
            display="absolute"
            fontWeight="light"
          >
            3
          </Text>
          <Text
            fontSize="14px"
            display={{ base: 'absolute', md: 'none' }}
            color="text.100"
          >
            Agenda
          </Text>
        </Center>
        <Text display={{ base: 'none', md: 'block' }} color="text.100">
          Agenda
        </Text>
      </Flex>
    </Flex>
  );
};
